﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class DeporteUserComponent {

    tabla: Tabla = {
        titulo: 'Deportes',
        endPoint:'/rest-api/user/deporte',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 10
            },
            {
                name: 'Deporte',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Medición',
                prop: 'medicion',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Cant. Mímina',
                prop: 'minimo',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Orden',
                prop: 'orden',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Puntos',
                prop: 'puntos',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Activo',
                prop: 'activo',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Individual',
                prop: 'individual',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 85
            },
            {
                name: 'Inter',
                prop: 'interhouses',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 85
            },
            {
                name: 'Boys',
                prop: 'boys',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 85
            },
            {
                name: 'Girls',
                prop: 'girls',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 85
            }
        ]
    };

}
